module.exports = __webpack_public_path__ + "static/media/tree-step-5_5.2a64c2f7.svg";